import React, { useContext } from "react";
import Image from "next/image";
import { DownloadIcon } from "@heroicons/react/outline";
import { DialogContext } from "contexts/DialogContext";
import { ACTIONS } from "reducers/dialogReducer";
import DocumentRequest from "components/DocumentRequest";
import { DocumentIcon } from "components/Icons";
import formatFileSize from "lib/formatFileSize";
import Button from "components/Button";

export default function ParagraphPosterFile({ data }) {
  const { dispatch } = useContext(DialogContext);
  const isPrivate = Object.prototype.hasOwnProperty.call(
    data,
    "field_private_file"
  );
  const file = isPrivate ? data.field_private_file : data.field_file;
  const splitted = file.filename.split(".");
  const extension = splitted.pop();
  const name = file.resourceIdObjMeta.description || splitted.join(".");
  const filesize = formatFileSize(file.filesize);

  const handleClick = () => {
    if (isPrivate) {
      dispatch({
        type: ACTIONS.OPEN,
        payload: {
          title: "Demande de documentation",
          body: <DocumentRequest file={file} />,
        },
      });
    } else if (typeof window !== "undefined") {
      window.location.assign(
        `/api/file/download?filename=${encodeURIComponent(
          file.filename
        )}&uri=${encodeURIComponent(file.uri.value)}`
      );
    }
  };

  return (
    <div
      className="group bg-primary text-white shadow-spread rounded-lg overflow-hidden cursor-pointer transition-colors"
      onClick={handleClick}
    >
      <div className="sr-only">{data.field_title || name}</div>
      <div className="aspect-a4">
        <Image
          src={data.field_image.image_style_uri.a4}
          alt={data.field_image.resourceIdObjMeta.alt}
          layout="fill"
          objectFit="cover"
          objectPosition="center"
        />
        <div className="absolute inset-0 flex flex-col p-4 items-start justify-center bg-primary/50 opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="bg-primary-dark rounded-md p-4 w-full">
            <div className="mb-4">
              <div className="font-important text-xl font-medium capitalize mb-1">
                {data.field_title || name}
              </div>
              <div className="flex items-center gap-2 uppercase">
                <span>{extension}</span>
                <span>-</span>
                <span>{filesize}</span>
              </div>
            </div>
            <Button
              as="a"
              theme="primary"
              size="small"
              onClick={() => handleClick()}
              inverse
            >
              Télécharger
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
